import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileDTO } from '../../dtos/file.dto';
import { UploadType } from '../../enums/upload-type.enum';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class PlanActionItemFileService extends FileService {
  override uploadType = UploadType.ACTION_ITEM_ATTACHMENT;

  actionItemId: number | null = null;

  setActionItemId(id: number | null) {
    this.actionItemId = id;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postFormRequest(
      `growelab/implementation-plan/action-item/${this.actionItemId}/upload`,
      formData,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }

  override deleteFile(file: FileDTO) {
    const basedId = window.btoa(file.id.toString());
    return this.apiService.deleteRequest(
      `uploads/delete/implementation_action_item/${basedId}`
    );
  }
}
